// @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'HTMLElement | null'.
export const getActiveElement = (): HTMLElement | null => document.activeElement;
